<div class="nav-container-separator"></div>
<mat-accordion class="mat-dialog-accordion">
    <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header [expandedHeight]="'50px'" [collapsedHeight]="'50px'">
            <mat-panel-title id="accAccountCodeMaster">
                <div class="d-flex ">
                    <div class="d-flex eip-mr-20 flex-grow-1 align-items-center">
                        <p class="ff-3">Document</p>
                    </div>
                    <div class="d-flex justify-content-end">
                        <div class="icons-container view-page-wrap-icons d-flex">                    
                            <i aria-hidden="true" class="fa fa-paperclip fs-16 eip-mr-5 eip-link" (click)="$event.stopPropagation();attachmentClick()"></i>
                            <i class="fa fa-check-circle-o" aria-hidden="true" title="Approve" *ngIf="canApprove && !_ViewOnly" (click)="$event.stopPropagation();approveDocument(true)"></i>
                            <span *ngIf="isRejected"><i class="fa fa-ban" aria-hidden="true" title="Reject" *ngIf="canApprove && !_ViewOnly" (click)="$event.stopPropagation();approveDocument(false)"></i></span>
                            <i class="fa fa-share-o" aria-hidden="true" title="Share" *ngIf="canShare" (click)="$event.stopPropagation();shareDocument()"></i>
                            <i class="fa fa-envelope" aria-hidden="true" title="Mail" (click)="$event.stopPropagation();createMessageClick();" *ngIf="!_ViewOnly"></i>                          
                        </div>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="eip-mt-20" *ngFor="let data of data">
            <div class="eip-mt-20 eip-mb-10"><dynamic-form [repeatCount]=4 [disabled]="true"></dynamic-form></div>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                        <p class="view-label">Doc Serial No.</p>
                        <p class="view-data" id="lblwarehouse">
                            {{data.docNo}}
                        </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                        <p class="view-label">Document Properties(Opt)</p>
                        <p class="view-data" id="lblisConfidential">
                            <mat-slide-toggle color="primary" aria-checked="true" [disabled]=true checked={{data.isConfidential}}>
                                Confidential
                            </mat-slide-toggle>
                        </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                        <p class="view-label">Print Size(Opt)</p>
                        <p class="view-data">{{getSelectedPrintsize(data.printSize)}}
                        </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                        <p class="view-label">Title</p>
                        <p class="view-data">{{data.title}}
                        </p>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="view-info eip-mb-20">
                        <p class="view-label">Document Date</p>
                        <p class="view-data">{{data.docDate}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
                <mat-panel-title id="accAccountCodeMaster">
                    <div class="d-flex ">
                        <div class="d-flex eip-mr-20 flex-grow-1 align-center">
                            <p class=" ff-3">Document Revision</p>
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="eip-mt-20" *ngFor="let data of data">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Status</p>
                            <p class="view-data">{{getSelectedStatus(data.status)}}</p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Revision</p>
                            <p class="view-data" id="lblJob">
                                {{data.revision}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Revision Date</p>
                            <p class="view-data" id="lblwarehouse">
                                {{data.revisiedOn}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Authorized By</p>
                            <p class="view-data">{{data.docAuthorizedByName}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Reference</p>
                            <p class="view-data">{{data.reference}}</p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Comments</p>
                            <p class="view-data" id="lblJob">
                                {{data.comments}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">QR Code Tag</p>
                            <p class="view-data" id="lblJob">
                                <mat-slide-toggle color="primary" aria-checked="true" [disabled]=true checked={{data.qrCodeStatus}}>
                                </mat-slide-toggle>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header [expandedHeight]="'43px'" [collapsedHeight]="'43px'">
                <mat-panel-title id="accAccountCodeMaster">
                    <div class="d-flex ">
                        <div class="d-flex eip-mr-20 flex-grow-1 align-center">
                            <p class=" ff-3">Storage Location</p>
                        </div>
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="eip-mt-20" *ngFor="let data of data">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Location</p>
                            <p class="view-data">{{getSelectedLocation(data.location)}}</p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-2 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Building</p>
                            <p class="view-data" id="lblJob">
                                {{getSelectedBuilding(data.building)}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-2 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Floor</p>
                            <p class="view-data" id="lblwarehouse">
                                {{getSelectedFloor(data.floor)}}
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-2 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Rack</p>
                            <p class="view-data">{{getSelectedRack(data.rack)}}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">Shelf</p>
                            <p class="view-data">{{getSelectedShelf(data.shelf)}}</p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <div class="view-info eip-mb-20">
                            <p class="view-label">File Number</p>
                            <p class="view-data" id="lblJob">
                                {{data.fileNo}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-expansion-panel>
</mat-accordion>